goog.provide('el8.app.shared.dialog.viewInlinePdf');

goog.require('el8.app.pageLayout');
goog.require('el8.uiwidget.NewDialog');
goog.require('el8.template.app.shared.viewInlinePdf');


/**
 * This dialog renders a PDF (represented by a DocumentFile id) in a
 * large dialog on the current page, rather than opening it in a new tab.
 * If being used from a non-chart context, a patient id must be provided.
 */
el8.app.shared.dialog.viewInlinePdf = (function() {

    var that = new el8.uiwidget.NewDialog({
        width: function() {
            return Math.min(950, Math.round(el8.app.pageLayout.getAppWidth() * 0.8));
        },
        height: function() {
            return el8.app.pageLayout.getChartInnerHeight();
        },
        // we want to make sure passport_emr users understand that the LHS exists
        position: (el8Globals.PASSPORT_EMR) ? 'right' : 'center',
        showXButton: true
    });

    var super_init = that._init;
    that._init = function() {
        super_init.call(that);
        that.getContentElt().on('click', '.download-pdf-trigger',  function() {
            var $this = $(this);
            var pdfUrl = el8.service.urls.get('downloadPdf', [$this.data('patient-id'), $this.data('id')]);
            window.open(pdfUrl);
        });
    };

    var super_show = that.show;
    that.show = function(spec) {
        super_show.call(that);

        var patientId = spec.patientId || el8Globals.PATIENT_ID;
        var pdfUrl = el8.service.urls.get('inlinePdf', [patientId, spec.docFileId]);
        // IE 11 won't redraw the object if we don't completely replace it in the DOM
        that.setContent(el8.template.app.shared.viewInlinePdf.content({pdfUrl: pdfUrl})); // clear the PDF

        $('.download-pdf-trigger', that.getContentElt()).data('id', spec.docFileId);
        $('.download-pdf-trigger', that.getContentElt()).data('patient-id', patientId);
        that.setTitle(spec.title || 'PDF');
    };

    var super_hide = that.hide;
    that.hide = function() {
        super_hide.call(that);
        that.setContent(el8.template.app.shared.viewInlinePdf.content({})); // clear the PDF
    };

    return that;

})();